const content: { [key: string]: any } = {
  title: {
    pageTitle: "CBR Clock",
    pageDescription: "IBOs whose CBR Clock has started",
  },
  sort: {
    ascending: "Most Urgent First",
    descending: "Least Urgent First",
  },
  export: {
    button: "Export",
    title: "Export Report",
    description: "This report will include a list of IBOs approaching their CBR compliance deadline.",
    exportTypeLabel: "CBR Clock",
  },
  info: {
    cbrClockInfoLabel: "CBR Clock information",
    cbrClockDescription:
      "Because these downline had personal PV and no VCS PV during the last month(s), their Criteria-based Reclassification (CBR) clock has started. To stop the clock, they must achieve 60% VCS or more in a bonus period by the close of month zero, or risk account deactivation.",
  },
  table: {
    columns: {
      aboName: "ABO Name / Number",
      cbrPeriodRemaining: "Remaining Months",
      cbrVcsPercent: "Current Month VCS %",
      cbrStartMonth: "Starting Month",
      cbrEndMonth: "Ending Month",
      watchlist: "Watchlist",
    },
  },
  losTreeView: "LOS Tree View",
} as const;

export default content;
